import React, { useState } from "react";
import axios from "axios";

const AdminSendEmail = () => {
  const [form, setForm] = useState({ to: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    try {
      const token = localStorage.getItem("adminToken");

     const res = await axios.post(
  "https://alkebulanfkalertbackend.onrender.com/api/users/send-email",
  form,
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  }
);

      setResult({ success: true, message: res.data.message });
      setForm({ to: "", subject: "", message: "" });
    } catch (err) {
      setResult({
        success: false,
        message: err.response?.data?.message || "Failed to send email",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow">
      <h2 className="text-2xl font-semibold mb-4">📧 Send Email to User</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Recipient Email</label>
          <input
            type="email"
            name="to"
            value={form.to}
            onChange={handleChange}
            placeholder="user@example.com"
            className="w-full border rounded-lg px-3 py-2 mt-1"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Subject</label>
          <input
            type="text"
            name="subject"
            value={form.subject}
            onChange={handleChange}
            placeholder="Email subject"
            className="w-full border rounded-lg px-3 py-2 mt-1"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Message</label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Write your message..."
            rows="6"
            className="w-full border rounded-lg px-3 py-2 mt-1"
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 disabled:opacity-60"
        >
          {loading ? "Sending..." : "Send Email"}
        </button>
      </form>

      {result && (
        <div
          className={`mt-4 p-3 rounded-lg text-center ${
            result.success ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
          }`}
        >
          {result.message}
        </div>
      )}
    </div>
  );
};

export default AdminSendEmail;

